import { Type } from "@angular/core"

export class CommonResponseModel<Type> {
    Data: Type;
    IsSuccess: boolean;
    ErrorMessage: string;

    constructor() {

    }
}